<script lang="ts">
  import type { Snippet } from 'svelte';

  /** `compact`: inside a card that already holds the action, so nothing empty takes the page. */
  let { compact = false, children }: { compact?: boolean; children?: Snippet } = $props();
</script>

<p class={compact ? 'py-4 text-center text-sm text-text-3' : 'page-enter py-10 text-center text-text-3'}>{@render children?.()}</p>
